import { gql } from "@apollo/client"

// mutation to update a specific action item
export const UPDATE_ACTION_ITEM = gql`
  mutation updateActionItem($id: Int!, $archived: Boolean) {
    updateActionItem(input: { id: $id, actionItem: { archived: $archived } }) {
      success
      errors {
        field
        messages
      }
      actionItem {
        id
        archived
        name
      }
    }
  }
`
// TODO for mutation - return success and error message top level
// mutation {
//   updateActionItem(input:{ id:257, name:"oooooooo", archived: false, planId:3}) {
//     name
//     planId
//   }
// }
